import { motion } from 'framer-motion';
import { useContent } from '@/context/ContentContext';

export default function Process() {
  const { t } = useContent();
  if (!t) return null;

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-20 sm:py-24 md:py-44 bg-paper-2 border-y border-[var(--line)]"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/28080033/pexels-photo-28080033.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          mixBlendMode: 'screen',
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start md:items-end mb-14 sm:mb-20 md:mb-32">
          <div className="md:col-span-3 font-mono text-[10px] uppercase tracking-[0.28em] sm:tracking-[0.3em] text-ember">
            § Chapter III · Manifesto
          </div>
          <div className="md:col-span-6">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight">
              {t.process.title}
            </h2>
          </div>
          <div className="md:col-span-3 text-ink-dim italic font-serif text-sm md:text-base">
            {t.process.subtitle}
          </div>
        </div>

        <ol className="space-y-0">
          {t.process.chapters.map((c, i) => (
            <motion.li
              key={i}
              data-testid={`process-chapter-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-6 md:gap-10 items-start py-8 sm:py-10 md:py-16 border-t border-[var(--line)]"
            >
              <div className="md:col-span-3">
                <div className="chapter-num text-5xl sm:text-6xl md:text-8xl leading-none">{c.num}</div>
                <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.28em] sm:tracking-[0.3em] text-ink-dim">
                  Chapter · {c.num}
                </div>
              </div>
              <div className="md:col-span-5">
                <h3 className="font-serif italic text-2xl sm:text-3xl md:text-5xl leading-tight">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-4 text-ink-dim text-sm md:text-base leading-relaxed">
                {c.desc}
              </div>
            </motion.li>
          ))}
          <div className="border-t border-[var(--line)]" />
        </ol>
      </div>
    </section>
  );
}
